import { useTranslation } from 'react-i18next'

import { Badge, type BadgeVariant } from '@percent/lemonade'
import type { GivingCampaignPartnerDto } from '@percent/partner-dashboard/services/workplaceGiving/workplaceGivingService.types'

const isCampaignEnded = (endDate: string) => {
  return new Date(endDate) < new Date()
}

const getVariant = ({ status, endDate }: { status: string; endDate: string | null }): BadgeVariant => {
  const isPublishedAndEnded = status === 'PUBLISHED' && endDate && isCampaignEnded(endDate)

  if (isPublishedAndEnded) return 'default'

  if (status === 'PUBLISHED') return 'positive'

  if (status === 'DRAFT') return 'default'

  if (status === 'CANCELLED') return 'critical'

  return 'default'
}

const getTranslationKey = ({ status, endDate }: { status: string; endDate: string | null }) => {
  const isPublishedAndEnded = status === 'PUBLISHED' && endDate && isCampaignEnded(endDate)

  if (isPublishedAndEnded) return 'status.past'

  if (status === 'PUBLISHED') return 'status.published'

  if (status === 'DRAFT') return 'status.draft'

  if (status === 'CANCELLED') return 'status.cancelled'

  return 'status.draft'
}

export function StatusBadge({ campaign }: { campaign: GivingCampaignPartnerDto }) {
  const { t } = useTranslation()

  return (
    <Badge variant={getVariant({ status: campaign.status, endDate: campaign.endDate })}>
      {t(getTranslationKey({ status: campaign.status, endDate: campaign.endDate }))}
    </Badge>
  )
}
